import {Message} from "element-ui";
import _request from "../common/_request";


let lib_requirement = {
    atbcity: function (callback) {
        let data = {};
        _request._get('/requirement/atbcity', data, function (response) {
            if (response.code !== _request.success) {
                Message.warning(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                console.log(response.data);
                
                callback(response.data)
            }
        })
    },
    atbseries: function (city, brand, callback) {
        let data = {};
        data.city = city;
        data.brand = brand;
        _request._get('/requirement/atbseries', data, function (response) {
            if (response.code !== _request.success) {
                Message.warning(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                console.log(response.data);
                callback(response.data)
            }
        })
    },
    atbclue: function (data, callback) {
        _request._post('/requirement/atbclue', data, function (response) {
            // console.log(response, '报名报名')
            if (response.code !== _request.success) {
                Message.success(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },




};
export default lib_requirement